export const prefix = 'tdesign-starter';
export const PREFIX_FIELD = 'h5-recycle';
export const TOKEN_NAME = `${PREFIX_FIELD}-token`;
